export const FETCH_DEAL = 'fetchDeal'
export const FETCH_DEALS = 'fetchDeals'
export const DEAL_RESET_STATE = 'dealResetState'
export const FETCH_DEALS_BY_CLIENT = 'dealsByClient'
export const FETCH_DEALS_BY_MONTH = 'dealsByMonth'

export const FETCH_USER = 'fetchUser'
export const USER_RESET_STATE = 'userResetState'

export const FETCH_FILTER = 'fetchFilter'
export const FILTER_UPDATE = 'filterUpdate'
export const FILTER_RESET_STATE = 'filterResetState'

export const FETCH_WEBSITES = 'fetchSites'

export const FETCH_TLDS = 'fetchTLDS'

export const FETCH_TAGS = 'fetchTags'

export const FETCH_CATEGORY = 'fetchCategory'
export const FETCH_CATEGORIES = 'fetchCategories'
export const CATEGORY_RESET_STATE = 'categoryResetState'
export const CATEGORY_SET_DEFAULT = 'categorySetDefault'